export default __webpack_public_path__ + "static/buoy-6c8dd4025ace31ba4328e83000ca7670.svg";